export default __webpack_public_path__ + "static/media/261.52349228.jpg";